"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnavHeader = void 0;
const ui_1 = require("@app/component/ui");
const util_1 = require("@app/util");
const use_workspace_unavailability_categories_1 = require("@app/util/hooks/use-workspace-unavailability-categories");
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const unavailability_context_1 = require("../unavailability-context");
const UnavHeader = ({ isEdit }) => {
    const { formControl, initialData, isEmployeeCalendar } = (0, unavailability_context_1.useUnavailability)();
    const isRequest = (0, util_1.isValue)(initialData?.requestPendingAction);
    const canCancelRequest = isEmployeeCalendar && isRequest;
    const categoryId = (0, react_hook_form_1.useWatch)({ control: formControl, name: 'categoryId' });
    const requestPendingAction = (0, react_hook_form_1.useWatch)({
        control: formControl,
        name: 'requestPendingAction',
    });
    const EDIT_KEY = categoryId === use_workspace_unavailability_categories_1.AVAILABILITY_VALUE
        ? 'EDIT_UNAVAILABILITY_AVAIL'
        : categoryId === use_workspace_unavailability_categories_1.UNAVAILABILITY_VALUE
            ? 'EDIT_UNAVAILABILITY'
            : 'EDIT_TIMEOFF_CATEGORY';
    const ADD_KEY = categoryId === use_workspace_unavailability_categories_1.AVAILABILITY_VALUE
        ? 'ADD_UNAVAILABILITY_AVAIL'
        : categoryId === use_workspace_unavailability_categories_1.UNAVAILABILITY_VALUE
            ? 'ADD_UNAVAILABILITY'
            : 'ADD_ABSENCE';
    const modalTitle = canCancelRequest
        ? (0, util_1.t)('CANCEL_UNAVAILABILITY_REQUEST')
        : isEdit || requestPendingAction
            ? (0, util_1.t)(EDIT_KEY)
            : (0, util_1.t)(ADD_KEY);
    return (react_1.default.createElement("div", { style: { display: 'flex', gap: '1rem', alignItems: 'center' } },
        react_1.default.createElement(ui_1.Text, { type: 'body-large', weight: 'bold' }, modalTitle)));
};
exports.UnavHeader = UnavHeader;
